module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp2_8003.1d79dbc0.png";